import { render, staticRenderFns } from "./PackageTracking.vue?vue&type=template&id=97d5b5ae&scoped=true&"
import script from "./PackageTracking.vue?vue&type=script&lang=js&"
export * from "./PackageTracking.vue?vue&type=script&lang=js&"
import style0 from "./PackageTracking.vue?vue&type=style&index=0&id=97d5b5ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d5b5ae",
  null
  
)

export default component.exports